
/**
 * 결제 주기
 */
export type PlanChangeOptionsResponseDowngradeOptionsItemBillingCycle = typeof PlanChangeOptionsResponseDowngradeOptionsItemBillingCycle[keyof typeof PlanChangeOptionsResponseDowngradeOptionsItemBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanChangeOptionsResponseDowngradeOptionsItemBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
